import React, { useMemo } from "react";
import { Tooltip } from "antd";
import { dateStringToStandardFormat } from "@/utils/dateFormatter";
import { NissanVehicleStatusMap, NissanVehicleStatusColorMap } from "@/utils/enum";
import Badge from "@/components/Badge";

const useTenderFileInputTableColumns = () => {
  return useMemo(
    () => [
      {
        title: "Vin",
        dataIndex: "vin",
        render: text => {
          return <span className="span-click">{text}</span>;
        },
      },
      {
        title: "Model",
        dataIndex: "model",
        render: (_, record) => {
          return <span className="span-click">{record.model}</span>;
        },
      },
      {
        title: "Received Date",
        dataIndex: "creationTime",
        render: text => {
          return <span className="span-click">{dateStringToStandardFormat(text, { showTime: true })}</span>;
        },
      },
      {
        title: "Dealer Name",
        dataIndex: "dealer.name",
        render: (_, record) => {
          return <span className="span-click">{record?.dealer?.name}</span>;
        },
      },
      {
        title: "Dealer Code",
        dataIndex: "dealer.code",
        render: (_, record) => {
          return <span className="span-click">{record?.dealer?.code}</span>;
        },
      },
      {
        title: "Warehouse",
        dataIndex: "vpcLocation.warehouse",
        render: (_, record) => {
          return <span className="span-click">{record?.vpcLocation?.warehouse}</span>;
        },
      },
      {
        // TODO: add pickup location
        title: "Pickup Location",
        dataIndex: "pickupAddress.name",
        render: (_, record) => {
          return (
            <span className="span-click">
              {[record.vpcLocation?.address, record.vpcLocation?.city, record.vpcLocation?.state]
                .filter(value => value)
                .join(", ")}{" "}
              {record.vpcLocation?.zipCode}
            </span>
          );
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        render: text => {
          return (
            <Tooltip title={NissanVehicleStatusMap[text]} color="white" trigger={["hover", "click"]}>
              <span className="span-click">
                <Badge color={NissanVehicleStatusColorMap[text]} text={NissanVehicleStatusMap[text]} />
              </span>
            </Tooltip>
          );
        },
      },
    ],
    [],
  );
};

export default useTenderFileInputTableColumns;
